<template>
  <div class="pt20">
    <div class="design_box_out">
      <!-- <p class="design_box_out_title"><i class="iconfont iconyou"></i>产品介绍</p> -->
      <div class="tool_company design_box banner-product">
		  <div>
			  <div v-if="property.radios == 1">
				  <!-- <p>经典单排</p> -->
				  <div class="box">
					  <img src="../../../public/static/img/image.png" alt="">
					  <div>
						  <div class="boxTitle">{{property.textareas}}</div>
						  <div class="tag">
							  <!-- <div class="tag1" v-if="property.view == 1">本店浏览量第1</div> -->
							  <div class="tag1">
								  限时优惠
								  <!-- <img v-if="property.view == 1" style="width: 100%;height: 100%;" src="../../assets/imgs/marshalling3.png" alt=""> -->
							  </div>
							  <div class="tag1">
								  店铺推荐
							  </div>
							  <div class="tags" v-if="property.faddish == 1">爆款</div>
							  <div class="tags" v-if="property.newProduct == 1">新品</div>
						  </div>
						  <div class="price">
							  <span style="font-size: 11px;">¥<span class="PresentPrice">90</span></span>
							  <span class="originalPrice">¥120</span>
						  </div>
					  </div>
				  </div>
			  </div>
			  <!-- <div class="link"></div> -->
			  <div v-if="property.radios == 2">
				  <!-- <p>经典双排</p> -->
				  <div class="box2">
					  <div>
						  <img src="../../../public/static/img/image.png" alt="">
						  <div class="title">比苹果X还薄的笔记本电脑折叠支架</div>
						  <div class="DoubleRowTag">
							  <div class="tags2" v-if="property.faddish == 1">爆款</div>
							  <div class="tags2s" v-if="property.newProduct == 1">新品</div>
						  </div>
						  <div class="DoubleRowPrice">
							  <span style="font-size: 11px;color: #FF1212;">¥<span class="PresentPrice">90</span></span>
							  <span class="originalPrice">¥120</span>
						  </div>
						  <div style="display: flex;">
							  <div class="tag2">限时优惠</div>
							  <div class="tag2">店铺推荐</div>
						  </div>
						  <!-- <div class="tag2" v-if="property.view == 1">限时优惠</div> -->
					  </div>
					  <div>
						  <img src="../../../public/static/img/image.png" alt="">
						  <div class="title">比苹果X还薄的笔记本电脑折叠支架</div>
						  <!-- <div class="DoubleRowTag">
							  <div class="tags2">爆款</div>
							  <div class="tags2s">新品</div>
						  </div> -->
						  <div class="DoubleRowPrice">
							  <span style="font-size: 11px;color: #FF1212;">¥<span class="PresentPrice">90</span></span>
							  <span class="originalPrice">¥120</span>
						  </div>
						  <div style="display: flex;">
							  <div class="tag2">限时优惠</div>
							  <div class="tag2">店铺推荐</div>
						  </div>
						  <!-- <div class="tag2" v-if="property.sale == 1">店铺推荐</div> -->
					  </div>
				  </div>
			  </div>
			  <div v-if="property.radios == 3">
				  <!-- <p>单排简易版</p> -->
				  <div class="box3">
						  <img src="../../../public/static/img/image.png" alt="">
				  </div>
			  </div>
			  <div v-if="property.radios == 4">
				  <!-- <p>双排简易版</p> -->
				  <div class="box4">
						  <img src="../../../public/static/img/image.png" alt="">
						  <img src="../../../public/static/img/image.png" alt="">
				  </div>
			  </div>
		  </div>
        <!-- <div class="product_swiper"
             :style="{'background':'url('+(property.pic[0]?property.pic[0]:'/static/img/userDefult.png')+') repeat scroll center center / cover'}">
        </div> -->
        <!-- <p class="product_swiper_crole"><span></span><span></span><span></span></p> -->
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ["property"],
    data() {
      return {
        form: {}
      };
    },
	created() {
		console.log(this.property,"this.property77==========")
	  // if (this.property.pic.length !== 0) {
	  //   let fileList = []
	  //   for (let i in this.property.pic) {
	  //     let fileList_line = {};
	  //     fileList_line.name = i;
	  //     fileList_line.url = this.property.pic[i];
	  //     fileList.push(fileList_line)
	  //   }
	  //   this.fileList = fileList
	  // }
	},
  };
</script>

<style>
	.boxTitle{
		overflow: hidden;
		/* text-overflow: ellipsis; */
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}
</style>



